/**
 * Role Entity
 * Represents a role in the RBAC system
 */
export interface RoleProps {
    roleId: string;
    name: string;
    description: string;
    isActive: boolean;
    permissions: string[];
    createdAt: Date;
    updatedAt: Date;
}

export class Role {
    private constructor(private readonly props: RoleProps) { }

    static create(props: RoleProps): Role {
        return new Role(props);
    }

    get roleId(): string {
        return this.props.roleId;
    }

    get name(): string {
        return this.props.name;
    }

    /**
     * Get formatted display name
     * Converts snake_case or underscore-separated names to Title Case
     * Examples: "super_admin" -> "Super Admin", "content_creator" -> "Content Creator"
     */
    get displayName(): string {
        return this.props.name
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    }

    get description(): string {
        return this.props.description;
    }

    get isActive(): boolean {
        return this.props.isActive;
    }

    get permissions(): string[] {
        return [...this.props.permissions];
    }

    get createdAt(): Date {
        return this.props.createdAt;
    }

    get updatedAt(): Date {
        return this.props.updatedAt;
    }

    hasPermission(permissionName: string): boolean {
        return this.props.permissions.includes(permissionName);
    }

    toJSON(): RoleProps {
        return {
            ...this.props,
            permissions: [...this.props.permissions],
        };
    }
}
